import React from 'react'
import Grid from 'library/atoms/Grid'
import { Text } from 'library/atoms/Typography'
import { Code } from 'shared/library/molecules/EmbedCode'
import Price, { PriceWrapper, PriceText } from 'shared/library/atoms/Price'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <Text as="div">
      <p>
        <Code>Price</Code> converts the <Code>pence</Code> prop to the specified{' '}
        <Code>currency</Code> and outputs it as formatted text. If true the{' '}
        <Code>wholeNumber</Code> prop rounds this up to the largest integer and
        displays that alone. It is primarily an abstraction of the
        <Code>money()</Code> function from <Code>helpers/money.ts</Code>,
        designed to save parent components making calls to the next router for
        user locale data. While <Code>money()</Code> can be used directly this
        is discouraged.
      </p>
      <p>
        <Code>PriceWrapper</Code> and <Code>PriceText</Code> are styling
        wrappers that can be used in conjunction to style sections of pricing
        text individually. All of these components can be passed the{' '}
        <Code>fontStyle</Code> and
        <Code>color</Code> props.
      </p>
    </Text>
  ),
  examples: [
    {
      title: 'Price',
      code: `<Grid gridGap={2}>
  <Price pence={750} currency="gbp" />
  <Price pence={750} currency="gbp" wholeNumber="true" />
  <Price pence={750} currency="gbp" fontStyle="h3" color="secondary" strike="true"/>
</Grid>`,
      scope: { Grid, Price }
    },
    {
      title: 'PriceWrapper',
      code: `<Grid gridGap={2}>
  <PriceWrapper>
    <Price pence={899} currency="gbp"/>
    <PriceText fontStyle="p3"> / person</PriceText>
  </PriceWrapper>
  <PriceWrapper fontStyle="h5">
    <PriceText color="secondary" fontStyle="p4">From </PriceText>
    <Price pence={899} currency="gbp" wholeNumber={true} />
    <PriceText fontStyle="h5">pp</PriceText>
  </PriceWrapper>
</Grid>`,
      scope: { Grid, Price, PriceWrapper, PriceText }
    }
  ]
}

const PriceStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default PriceStyleGuide
